import React from 'react';
import { fitSvgToContainer } from 'src/pages/PlannerPage/DeviceView/svgIconUtils';

export default function TintedSVG({ svg, color, size = 30 }: { svg: string; color: string; size?: number }) {
    return (
        <div
            style={{
                display: 'inline-block',
                width: size,
                height: size,
                color
            }}
            dangerouslySetInnerHTML={{
                __html: fitSvgToContainer(svg),
            }}
        />
    );
}